<template>
  <div :class="{ 'licences': true, 'is-loading': !loaded }">
    <d-alert
      v-if="referenceId === 0"
      theme="light"
      show
      class="text-center">
      You will be able to see and add licences after saving this crew.
    </d-alert>

    <d-alert
      v-if="loadError"
      theme="warning"
      show
      class="text-center">
      An error occurred during loading licences.
    </d-alert>

    <d-row
      v-if="loaded && !loadError && referenceId !== 0"
      class="pr-3 mb-3">
      <d-button
        theme="success"
        size="sm"
        @click.prevent="addLicence"
        outline
        class="ml-auto">
        Add licence
      </d-button>
    </d-row>

    <d-row
      v-if="loaded && !loadError && referenceId !== 0 && licences.length > 0"
      class="pl-3 pr-3">
      <table class="table table-bordered table-sm">
        <tbody>
          <licences-list-item
            v-for="(licenceData, index) of licences"
            :key="'licences-list-item-' + index"
            :licenceData="licenceData" />
        </tbody>
      </table>
    </d-row>

    <d-alert
      v-if="loaded && !loadError && referenceId !== 0 && licences.length === 0"
      theme="light"
      show
      class="text-center">
      There are no licences for this crew.
    </d-alert>
  </div>
</template>

<script>
import FormUtils from './../../utils/FormUtils.js';
import LicencesListItem from './LicencesListItem.vue';

export default {
  name: 'licences',
  components: {
    'licences-list-item': LicencesListItem
  },
  props: {
    referenceType: {
      type: String,
      required: true
    },
    referenceId: {
      type: Number,
      required: true
    },
    itemName: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      loaded: false,
      loadError: false,
      licences: []
    };
  },
  mounted () {
    if (this.referenceId === 0) {
      this.loaded = true;
    } else {
      this.loadLicences();
    }

    this.$bus.$on('licences-list-reload', this.reload);
  },
  methods: {
    loadLicences () {
      FormUtils.loadAdditionalData(this, {
        endpoint: '/crews/licences/items/' + parseInt(this.referenceId, 10),
        params: {
          pagination: 0
        },
        loadedKey: 'loaded',
        outputKey: 'licences',
        errorKey: 'loadError'
      });
    },
    addLicence () {
      this.$bus.$emit('show-licence-popup', this.referenceId);
    },
    reload () {
      this.loaded = false;
      this.loadLicences();
    }
  },
  beforeDestroy () {
    this.$bus.$off('licences-list-reload', this.reload);
  }
}
</script>

<style lang="scss" scoped>
.licences {
  margin: -32px 0 20px 0;
  position: relative;

  &.is-loading {
    fieldset {
      min-height: 120px;
    }

    &:after {
      background: rgba(255, 255, 255, .66);
      content: "";
      height: 100%;
      left: 0;
      position: absolute;
      top: 0;
      width: 100%;
    }

    &:before {
      content: "Loading data...";
      left: 50%;
      position: absolute;
      top: 50%;
      transform: translateX(-50%) translateY(-50%);
      z-index: 1;
    }
  }
}
</style>
